module.exports = __webpack_public_path__ + "static/media/back.fdef52dd.svg";